import { dispatchAnalyticEvent } from '@/components/webcomponents/Global/analyticsEvents'
import type {
  CallbackEvent,
  TableRowCellButtonClick,
} from '@/components/webcomponents/DataTable/types/Table.type'

export function createButtonClickCell(
  cell: TableRowCellButtonClick,
  componentName: string,
  element: HTMLElement,
  callback: ((e: CallbackEvent) => void) | null,
): HTMLTableCellElement {
  const td = document.createElement('td')
  td.part = 'cell'
  const button = document.createElement('wa-button')
  button.part = 'cell-button'
  button.setAttribute('exportparts', 'base:cell-button-base')
  button.setAttribute('appearance', 'outlined')
  button.setAttribute('variant', 'neutral')
  button.setAttribute('size', 'small')
  button.innerText = cell.text || ''

  button.addEventListener('click', () => {
    // Fire analytics event for table sorting
    dispatchAnalyticEvent('ascend_table_cellbutton_clicked', 'click', componentName, {
      label: `${button.innerText || 'unknown'}`,
    })

    const eventData = { actionType: 'click-cell' as const, key: cell.clickEvent?.key ?? '' }

    if (callback) {
      document.AscendAwesome?.LogManager?.logWarning('callback is deprecated. See docs.')
      callback(eventData)
    }

    if (element && typeof element.dispatchEvent === 'function') {
      element.dispatchEvent(
        new CustomEvent('click-cell', {
          detail: eventData,
          bubbles: true,
          composed: true,
        }),
      )
    }
  })

  td.appendChild(button)

  return td
}
